module.exports = __webpack_public_path__ + "static/media/features-tabs-icon-01.9eb8bd3c.svg";